import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Blog extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }

  get mobileBackgroundImage() {
    return get(this, '_mobile_background_image.value[0].url', '');
  }

  get backgroundImage() {
    return get(this, '_background_image.value[0].url', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }

  get linkText() {
    return get(this, '_link_text.value', '');
  }

  get slug() {
    return get(this, '_product_slugs.taxonomyTerms[0].name', '/');
  }
}



// WEBPACK FOOTER //
// ./src/models/LinkBanner.model.js